<template>
  <div class="form-group">
    <label v-if="label" :for="inputId" :class="`col-sm-${+labelCols} control-label`">{{
      label
    }}</label>
    <div :class="label ? `col-sm-${12 - +labelCols}` : ''">
      <BaseSelect
        :value="value"
        :clearable="clearable"
        :disabled="disabled"
        :options="options"
        :placeholder="placeholder"
        :searchable="searchable"
        :filterable="filterable"
        :search-function="searchFunction"
        :option-label-key="optionLabelKey"
        :option-value-key="optionValueKey"
        :no-data-text="noDataText"
        :classes="error ? 'has-error' : ''"
        @input="$emit('input', $event)"
      />
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import i18n from '@/translations/i18n';
import BaseSelect from './BaseSelect';

export default {
  name: 'BaseFormSelect',

  components: { BaseSelect },

  props: {
    value: {
      type: [Object, String, Number],
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelCols: {
      type: [Number, String],
      default: 6,
    },
    options: {
      type: Array,
      required: true,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    searchFunction: {
      type: Function,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    optionLabelKey: {
      type: String,
      default: 'name',
    },
    optionValueKey: {
      type: String,
      default: 'code',
    },
    noDataText: {
      type: String,
      default: i18n.t('common.noData'),
    },
  },

  data() {
    return {
      inputId: '',
    };
  },

  created() {
    this.inputId = this.id || uuidv4();
  },
};
</script>
